var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "popup-wrap" }, [
    _c("div", { staticClass: "border-radius-8 popup-content" }, [
      _c("div", { staticClass: "bind-wrap" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("lLinkAccount"))),
        ]),
        _c(
          "div",
          { staticClass: "account-list" },
          [
            _c("AccountFunplus", {
              attrs: { info: _vm.bindInfo.funplus_id },
              on: { changePopup: _vm.handleChangePopup },
            }),
            _c("AccountGoogle", { attrs: { info: _vm.bindInfo.google } }),
            _c("AccountFacebook", { attrs: { info: _vm.bindInfo.facebook } }),
          ],
          1
        ),
      ]),
      _c("a", {
        staticClass: "btn-popup-close",
        attrs: { href: "javascript:;" },
        on: {
          click: function ($event) {
            return _vm.$emit("changePopup", { name: "" })
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }